import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class MachinesApi extends ApiModule {
	constructor() {
		super(ModulesMap.MACHINES, {
			entity: 'machines',
		})
	}

	getSensorsValues(options = {}) {
		const config = {
			url: this.generateUrl(true, {
				suffix: 'sensor_values',
			}),
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}

	getRawGPSParams(options = {}) {
		const config = {
			url: this.generateUrl(true, {
				suffix: 'raw_gps_params',
			}),
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}
}
